var C = Object.defineProperty;
var F = (t, e, i) => e in t ? C(t, e, { enumerable: !0, configurable: !0, writable: !0, value: i }) : t[e] = i;
var h = (t, e, i) => F(t, typeof e != "symbol" ? e + "" : e, i);
import * as f from "react";
import { useId as L, useEffect as A } from "react";
import "react-dom";
/*! react-a11y-dialog 7.3.0 — © Kitty Giraudel */
const n = ":not([inert]):not([inert] *)", r = ':not([tabindex^="-"])', u = ":not(:disabled)";
var x = [`a[href]${n}${r}`, `area[href]${n}${r}`, `input:not([type="hidden"]):not([type="radio"])${n}${r}${u}`, `input[type="radio"]${n}${r}${u}`, `select${n}${r}${u}`, `textarea${n}${r}${u}`, `button${n}${r}${u}`, `details${n} > summary:first-of-type${r}`, `iframe${n}${r}`, `audio[controls]${n}${r}`, `video[controls]${n}${r}`, `[contenteditable]${n}${r}`, `[tabindex]${n}${r}`];
function g(t) {
  (t.querySelector("[autofocus]") || t).focus();
}
function c(t, e) {
  if (e && w(t)) return t;
  if (!((i = t).shadowRoot && i.getAttribute("tabindex") === "-1" || i.matches(":disabled,[hidden],[inert]"))) if (t.shadowRoot) {
    let s = v(t.shadowRoot, e);
    for (; s; ) {
      const o = c(s, e);
      if (o) return o;
      s = p(s, e);
    }
  } else if (t.localName === "slot") {
    const s = t.assignedElements({ flatten: !0 });
    e || s.reverse();
    for (const o of s) {
      const l = c(o, e);
      if (l) return l;
    }
  } else {
    let s = v(t, e);
    for (; s; ) {
      const o = c(s, e);
      if (o) return o;
      s = p(s, e);
    }
  }
  var i;
  return !e && w(t) ? t : null;
}
function v(t, e) {
  return e ? t.firstElementChild : t.lastElementChild;
}
function p(t, e) {
  return e ? t.nextElementSibling : t.previousElementSibling;
}
const w = (t) => {
  var e;
  return !((e = t.shadowRoot) != null && e.delegatesFocus) && t.matches(x.join(",")) && !((i) => !(!i.matches("details:not([open]) *") || i.matches("details>summary:first-of-type")) || !(i.offsetWidth || i.offsetHeight || i.getClientRects().length))(t);
};
function y(t = document) {
  const e = t.activeElement;
  return e ? e.shadowRoot ? y(e.shadowRoot) || document.activeElement : e : null;
}
function R(t, e) {
  const [i, s] = function(l) {
    const a = c(l, !0);
    return [a, a ? c(l, !1) || a : null];
  }(t);
  if (!i) return e.preventDefault();
  const o = y();
  e.shiftKey && o === i ? (s.focus(), e.preventDefault()) : e.shiftKey || o !== s || (i.focus(), e.preventDefault());
}
let k = class {
  constructor(t) {
    h(this, "$el");
    h(this, "id");
    h(this, "previouslyFocused");
    h(this, "shown");
    this.$el = t, this.id = this.$el.getAttribute("data-a11y-dialog") || this.$el.id, this.previouslyFocused = null, this.shown = !1, this.maintainFocus = this.maintainFocus.bind(this), this.bindKeypress = this.bindKeypress.bind(this), this.handleTriggerClicks = this.handleTriggerClicks.bind(this), this.show = this.show.bind(this), this.hide = this.hide.bind(this), this.$el.setAttribute("aria-hidden", "true"), this.$el.setAttribute("aria-modal", "true"), this.$el.setAttribute("tabindex", "-1"), this.$el.hasAttribute("role") || this.$el.setAttribute("role", "dialog"), document.addEventListener("click", this.handleTriggerClicks, !0);
  }
  destroy() {
    return this.hide(), document.removeEventListener("click", this.handleTriggerClicks, !0), this.$el.replaceWith(this.$el.cloneNode(!0)), this.fire("destroy"), this;
  }
  show(t) {
    var e;
    return this.shown || (this.shown = !0, this.$el.removeAttribute("aria-hidden"), this.previouslyFocused = y(), ((e = this.previouslyFocused) == null ? void 0 : e.tagName) === "BODY" && (t != null && t.target) && (this.previouslyFocused = t.target), g(this.$el), document.body.addEventListener("focus", this.maintainFocus, !0), this.$el.addEventListener("keydown", this.bindKeypress, !0), this.fire("show", t)), this;
  }
  hide(t) {
    var e, i;
    return this.shown ? (this.shown = !1, this.$el.setAttribute("aria-hidden", "true"), (i = (e = this.previouslyFocused) == null ? void 0 : e.focus) == null || i.call(e), document.body.removeEventListener("focus", this.maintainFocus, !0), this.$el.removeEventListener("keydown", this.bindKeypress, !0), this.fire("hide", t), this) : this;
  }
  on(t, e, i) {
    return this.$el.addEventListener(t, e, i), this;
  }
  off(t, e, i) {
    return this.$el.removeEventListener(t, e, i), this;
  }
  fire(t, e) {
    this.$el.dispatchEvent(new CustomEvent(t, { detail: e, cancelable: !0 }));
  }
  handleTriggerClicks(t) {
    const e = t.target;
    e.closest(`[data-a11y-dialog-show="${this.id}"]`) && this.show(t), (e.closest(`[data-a11y-dialog-hide="${this.id}"]`) || e.closest("[data-a11y-dialog-hide]") && e.closest('[aria-modal="true"]') === this.$el) && this.hide(t);
  }
  bindKeypress(t) {
    var e;
    ((e = document.activeElement) == null ? void 0 : e.closest('[aria-modal="true"]')) === this.$el && (t.key === "Escape" && this.$el.getAttribute("role") !== "alertdialog" && (t.preventDefault(), this.hide(t)), t.key === "Tab" && R(this.$el, t));
  }
  maintainFocus(t) {
    t.target.closest('[aria-modal="true"], [data-a11y-dialog-ignore-focus-trap]') || g(this.$el);
  }
};
function E() {
  for (const t of document.querySelectorAll("[data-a11y-dialog]")) new k(t);
}
typeof document < "u" && (document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", E) : E());
const K = (t) => {
  const { role: e = "dialog", id: i, titleId: s = `${i}-title` } = t, [o, l] = (() => {
    const [m, d] = f.useState(null);
    return [m, f.useCallback((b) => {
      b !== null && d(new k(b));
    }, [])];
  })(), a = f.useCallback(() => o && o.hide(), [o]), $ = e === "alertdialog";
  return f.useEffect(() => () => {
    o && o.destroy();
  }, [o]), [o, { container: { id: i, ref: l, role: e, tabIndex: -1, "aria-modal": !0, "aria-hidden": !0, "aria-labelledby": s }, overlay: { onClick: $ ? void 0 : a }, dialog: { role: "document" }, closeButton: { type: "button", onClick: a }, title: { role: "heading", "aria-level": 1, id: s } }];
}, I = () => {
  const t = L();
  let e = null, i = null;
  const [s, o] = K({
    id: `modal-${t}`
  }), l = () => {
    document.body.classList.add("overflow-hidden"), i == null || i();
  }, a = () => {
    document.body.classList.remove("overflow-hidden"), e == null || e();
  };
  A(() => {
    if (s)
      return s.on("show", l), s.on("hide", a), () => {
        s.off("show", l), s.off("hide", a);
      };
  }, [s]);
  const $ = (d) => {
    e = d;
  }, m = (d) => {
    i = d;
  };
  return { attr: o, close: s == null ? void 0 : s.hide, onClose: $, onOpen: m, open: s == null ? void 0 : s.show };
};
export {
  I as default
};
